import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { HomePage } from './pages/HomePage';
import { AboutPage } from './pages/AboutPage';
import { ProofPage } from './pages/ProofPage';
import { ClassesPage } from './pages/ClassesPage';
import { SchedulePage } from './pages/SchedulePage';
import { ResourcesPage } from './pages/ResourcesPage';
import { BlogPage } from './pages/BlogPage';
import { ContactPage } from './pages/ContactPage';
import { AskTheCoach } from './components/AskTheCoach';
export function App() {
  return <BrowserRouter data-id="element-0">
      <Routes data-id="element-1">
        <Route path="/" element={<HomePage data-id="element-3" />} data-id="element-2" />
        <Route path="/about" element={<AboutPage data-id="element-5" />} data-id="element-4" />
        <Route path="/classes" element={<ClassesPage data-id="element-7" />} data-id="element-6" />
        <Route path="/schedule" element={<SchedulePage data-id="element-9" />} data-id="element-8" />
        <Route path="/resources" element={<ResourcesPage data-id="element-11" />} data-id="element-10" />
        <Route path="/blog" element={<BlogPage data-id="element-13" />} data-id="element-12" />
        <Route path="/proof" element={<ProofPage data-id="element-15" />} data-id="element-14" />
        <Route path="/contact" element={<ContactPage data-id="element-17" />} data-id="element-16" />
      </Routes>
      <AskTheCoach data-id="element-18" />
    </BrowserRouter>;
}